document.addEventListener('DOMContentLoaded', function() {

    let emailToChange = document.querySelectorAll('.help-card-text');
    let urlDomain = window.location.hostname;

    if (urlDomain === 'ostrichpillow.com') {
      emailToChange[0].innerHTML = emailToChange[0].innerHTML.replace('hi@ostrichpillow.com', 'hello@ostrichpillow.com');
      emailToChange[2].innerHTML = emailToChange[2].innerHTML.replace('hi@ostrichpillow.com', 'hello@ostrichpillow.com');
    }
});